import React, { useState, useEffect } from "react";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Grid, Hidden } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import Pagination from "@material-ui/lab/Pagination";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Routes from "../../../config/routes";
import "./_announcement.css";
import moment from "moment";
import { routePaths } from "../../../config/route-paths";
import { grey900 } from "material-ui/styles/colors";
import { history } from "../../../../helpers";
import { pathActions } from "../../../../actions";
import { useDispatch } from "react-redux";
import { updateAnnouncementVal } from "../model/announcement-action";

const announcementBannerStyles = makeStyles((theme) => ({
  lowerFont: {
    color: theme.palette.eTertiary.base + "!important",
    "&:hover": {
      color: theme.palette.eTertiary.base,
    },
    cursor: "pointer",
  },
  mainContent: {
    marginTop: "70px",
  },
  announcementStyle:{
    marginTop:"70px",
    width:"100%"
  },
  disabledColour:{
    "& .Mui-disabled" :{
      opacity: "0.38"
  }}
}));
const AlertwithStyle = withStyles(() => ({
  action: {
    alignItems: "flex-start",
  },
  message: {
    width: "100%",
    minHeight:"80px"
  },
}))(Alert);

export default function Announcement(props) {
  const [open, setOpen] = React.useState(false);
  const [announcementLength, setAnnouncementLength] = useState(null);
  const path = useSelector((store)=>store?.location);
  const dispatch = useDispatch();
  useEffect(() => {
    function updateSize() {
      const width = (window.innerWidth * 9) / 23;
      setAnnouncementLength(width);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  const customStyle = announcementBannerStyles();
  const labels = useSelector(
    (state) => state?.labels?.data?.getLabels?.ANNOUNCEMENTS
  );
  const announcementDetails = useSelector((state) => {
    let fin =
      state?.announcementReducer?.annResults?.data?.getAnnouncementList.filter(
        (obj) => obj.AnnouncementType === "BANNER"
      );
    let ls = [];
    if (localStorage.getItem("banner")) {
      ls.push(localStorage.getItem("banner").split(","));
    }
    if (ls[0] === undefined) {
      return fin?.sort((a, b) => {
        let a_date_format = moment(a.StartDate).format("MM-DD-YYYY hh:mm:ss");
        let b_date_format = moment(b.StartDate).format("MM-DD-YYYY hh:mm:ss");
        return new Date(b_date_format) - new Date(a_date_format);
      });
    } else {
      var filtered = fin?.filter(function (e) {
        return this.indexOf(e.AnnouncementId.toString()) < 0;
      }, ls[0]);
      return filtered?.sort((a, b) => {
        let a_date_format = moment(a.StartDate).format("MM-DD-YYYY hh:mm:ss");
        let b_date_format = moment(b.StartDate).format("MM-DD-YYYY hh:mm:ss");
        return new Date(b_date_format) - new Date(a_date_format);
      });
    }
  });
  const [showData,setShowData]=useState(true)
  useEffect(()=>{
    if(path.login || path.signup || window.location.pathname.startsWith(routePaths.LOGIN) || window.location.pathname === routePaths.LOGIN_VIA_OTP || window.location.pathname === routePaths.REGISTER){
      setShowData(true)
    }else{
      setShowData(false)
    }
  },[path,window.location.pathname])

  const [page, setPage] = useState(1);
  const [noOfQuestions, setNoOfQuestions] = useState(1);

  const [annFilter, setAnnFilter] = useState(announcementDetails);
  let [clearAnn, setClearAnn] = useState(false);
  let [expand,setExpand] = useState(false)

  let clearAnnouncement = (event) => {
    setClearAnn(false);
  };

  let [noData, actualData, count, details] = useUpdateData(
    page,
    announcementDetails,
    noOfQuestions
  );
  const [fullData, setFullData] = useState([]);
  const handleChange = (event, newPage) => {
    setPage(newPage);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleDismiss = (id, ind) => {
    setAnnFilter(announcementDetails.splice(ind, 1));
    let existing = localStorage.getItem("banner");
    existing = existing ? existing.split(",") : [];
    existing.push(id);
    localStorage.setItem("banner", existing.toString());
    setOpen(false);
  };
  useEffect(() => {
    let x = document.querySelector(".Mui-disabled");
    let target = "";
    if (x) {
      target = x.getAttribute("disabled");
    }
    if (target !== null) {
      var all = document.getElementsByClassName("MuiPaginationItem-icon");
      if (all.length > 0) {
        if (page >= 2) {
          all[1].style.color = grey900;
        } else {
          all[0].style.color = grey900;
        }
      }
    } else {
      var all = document.getElementsByClassName("MuiPaginationItem-icon");
      for (var i = 0; i < all.length; i++) {
        all[i].style.color = grey900;
      }
    }
  }, [page]);

   return showData && details && details.length > 0 ? (
    <Grid container direction="column">
     <Grid item xs={12}>
        <div>
          {details?.map((val, ind) => {
            return (
              <AlertwithStyle
                key={ind}
                icon={false}
                severity="error"
                className={customStyle.announcementStyle}
                onClose={handleClickOpen}
              >
                <AlertTitle>
                  <strong> {labels?.ANNOUNCEMENT_TITLE}</strong>
                </AlertTitle>
                <Grid container direction="row">
                  <Grid item xs={12}>
                  <span
                  dangerouslySetInnerHTML={{
                    __html: val?.AnnouncementDescription.length > announcementLength ? val?.AnnouncementDescription.split(" ",announcementLength/15).join(" ") + " ...  " :val?.AnnouncementDescription,
                  }}
                />
                 <a
                    className={customStyle.lowerFont}
                    onClick={() => {
                      history.push(routePaths.ANNOUNEMENT);
                      dispatch(pathActions.getLocationPath(routePaths.ANNOUNEMENT));
                      dispatch(updateAnnouncementVal(val.AnnouncementId))

                    }}
                    >
                      {val?.AnnouncementDescription.length > announcementLength 
                        ? labels?.ANNOUNCEMENT_READ_MORE
                        : ""}
                   </a>
                  </Grid>

                  <Dialog
                    open={open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      {labels?.DISMISS_TITLE}
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        {labels?.DISMISS_CONTENT}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleClose} color="primary">
                        {labels?.DISMISS_NO}
                      </Button>
                      <Button
                        onClick={()=>handleDismiss(val?.AnnouncementId, ind)}
                        color="primary"
                        autoFocus
                      >
                        {labels?.DISMISS_YES}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>
                {announcementDetails?.length > 1 ? (
                  <Grid justify="center" item container>
                    <Pagination
                      onChange={handleChange}
                      page={page}
                      count={count}
                      color="primary"
                      className={customStyle.disabledColour}
                    />
                  </Grid>
                ) : null}
              </AlertwithStyle>
            );
          })}
        </div>
        </Grid>
      <Grid item xs={12}>
        <Routes />
      </Grid>
    </Grid>
  ) : (
    <div className={customStyle.mainContent}>
      <Routes />
    </div>
  );
}

const useUpdateData = (page, data, noOfQuestions) => {
  data = data || 0;
  let setNoData = false;
  let setActualData = data;
  let details = [];

  let i = (page - 1) * noOfQuestions;
  for (i; i < page * noOfQuestions; i++) {
    if (i === data?.length) {
      details[i] = data[i - 1];
    } else {
      details[i] = data[i];
    }
  }
  const count = Math.floor(
    data?.length / noOfQuestions + (data?.length % noOfQuestions === 0 ? 0 : 1)
  );

  let setCount = count;
  let setDetails = "";
  if (count === 0) {
    setDetails = [];
  } else {
    setDetails = details?.filter((obj) => obj !== undefined);
  }
  return [setNoData, setActualData, setCount, setDetails];
};
